import get from 'lodash.get';
import { getEvents } from '@/services/event';

const initializeEvents = async ({ commit }) => {
  const getEventsResponse = await getEvents();
  const mealEvents = get(getEventsResponse, 'data.getEvents');
  if (mealEvents) {
    const noMenuConfig = {
      breakfast: {
        hasSVGIcon: true,
        noMenuIcon: 'breakfast-no-menu',
        noMenuText: '',
      },
      lunch: {
        hasSVGIcon: false,
        noMenuIcon: '',
        noMenuText: 'calendar.lunchNoMenu',
      },
    };

    const dinnerMealEventName = 'Dinner';

    return mealEvents
      .filter(({ name }) => name !== dinnerMealEventName)
      .map((mealEvent) => ({
        id: mealEvent.id,
        name: mealEvent.name.toLowerCase(),
        capitalized: mealEvent.name,
        noMealLabel: `calendar.noMeal${mealEvent.name}`,
        label: `calendar.event${mealEvent.name}`,
        ...noMenuConfig[mealEvent.name.toLowerCase()],
      }));
  }
  commit('global/SET_MESSAGE_ERROR', { message: 'calendar.unableToFetchEvents' }, { root: true });
  return [];
};

export default {
  initializeEvents,
};



// WEBPACK FOOTER //
// ./store/modules/events/actions.js